import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { paths } from 'src/routes/paths';
import { enqueueSnackbar } from 'notistack';
import * as traineeService from './trainee.services';

export const loadTrainee = createAsyncThunk( 'trainee/load', async ( userId ) =>
       traineeService.getAllTrainee( userId )
);

export const deleteTrainee = createAsyncThunk( 'trainee/delete', async ( traineeObject ) =>
       traineeService.deleteTrainee( traineeObject )
);

export const deleteTraineeWithoutRedirect = createAsyncThunk(
       'trainee/deleteWithoutRedirect',
       async ( traineeObject, redirect ) => traineeService.deleteTrainee( traineeObject )
);

export const traineeSlice = createSlice( {
       name: 'trainee',
       initialState: {
              traineeTab: [],
              isLoading: false,
              isTaineeDeleting: false,
              isTraineeGeted: false,
              error: '',

              traineeGetFromDelete: {},
              deleteTraineeSuccess: false,
       },
       reducers: {
              initTrainee: ( state, action ) =>
              {
                     state.traineeTab = [ ...action.payload ];
              },
              initDeleteTraindelete: ( state, action ) =>
              {
                     state.traineeGetFromDelete = { ...state.traineeGetFromDelete, ...action.payload };
              },
              resetDeleteTraineeSuccess: ( state ) =>
              {
                     state.deleteTraineeSuccess = false;
                     state.isTaineeDeleting = false;
              },
              resetData: ( state ) =>
              {

                     state.traineeTab = [];
                     state.isTraineeGeted = false;
                     state.isLoading = false; // Optionnel : réinitialiser l'état de chargement si nécessaire
              },

       },
       extraReducers: ( builder ) =>
       {
              builder
                     .addCase( loadTrainee.pending, ( state ) =>
                     {
                            state.isLoading = true;
                            state.isTraineeGeted = false;
                     } )
                     .addCase( loadTrainee.fulfilled, ( state, action ) =>
                     {
                            state.isLoading = false;
                            state.isTraineeGeted = true;
                            state.traineeTab = [ ...action.payload.data ];
                     } )
                     .addCase( loadTrainee.rejected, ( state, action ) =>
                     {
                            state.isLoading = false;
                            state.isTraineeGeted = false;
                            state.error = action?.payload?.data ? action.payload.message : action.error.message;
                     } );















              builder
                     .addCase( deleteTrainee.pending, ( state ) =>
                     {
                            state.isTaineeDeleting = true;
                            state.deleteTraineeSuccess = false;
                            // console.log( 'suppression en cour:' );
                     } )
                     .addCase( deleteTrainee.fulfilled, ( state, action ) =>
                     {
                            state.isTaineeDeleting = false;
                            state.deleteTraineeSuccess = true;
                            enqueueSnackbar( 'Stagiaire supprimé avec succès !' );
                            state.traineeGetFromDelete = {
                                   ...action.payload,
                            };
                            // console.log( 'stagiaire supprimer avec succès:', action.payload );
                            // redirect();
                     } )
                     .addCase( deleteTrainee.rejected, ( state, action ) =>
                     {
                            state.isTaineeDeleting = false;
                            state.deleteTraineeSuccess = false;
                            state.error = action?.payload?.data ? action.payload.message : action.error.message;
                            // console.log( "Erreur lors de la supression de l'stagiaire:", state.error );
                     } );
















       },
} );
const redirect = () =>
{
       setTimeout( () =>
       {
              window.location.href = paths.trainee;
              resetDeleteTraineeSuccess();

       }, 100 );
};
export const { initTrainee, initDeleteTraindelete, resetDeleteTraineeSuccess, resetData } =
       traineeSlice.actions;
export default traineeSlice.reducer;
